import RemindersAndUpdatesContainer from './RemindersAndUpdatesContainer';

export default RemindersAndUpdatesContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/RemindersAndUpdates/index.js